const DAILY_BONUS_UP_TO_AMOUNTS_BY_INDEX = [25, 15, 10, 8, 7, 4.5, 3, 2, 1, 0.5];

export const getDailyBonusUpToByIndex = (index: number, fallback: number) => {
  return DAILY_BONUS_UP_TO_AMOUNTS_BY_INDEX[index] ?? fallback;
};
